export default __webpack_public_path__ + "static/media/modifier-img.aaaea4a9.svg";